<h2 mat-dialog-title>Reset offerte verstuurd</h2>
<hr />

<mat-dialog-content>
  <br />
  <textarea-input
    [title]="'Reden'"
    [placeholder]="'Geef een reden aub'"
    [initContent]="reason"
    (answer)="reasonChange($event)"
  ></textarea-input>
</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <button type="button" (click)="closeDialog()" class="btn btn-main btn-back">
    Annuleer
  </button>
  <button
    type="button"
    (click)="resetQuotationSent()"
    mat-button
    class="button"
    id="btnSend"
    [disabled]="reason == null || reason.length === 0"
  >
    Reset
  </button>
</mat-dialog-actions>
